import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { BottomNav } from '../components/BottomNav';
interface DeveloperInfoPageProps {
  developerId: number;
  developerName: string;
  onClose: () => void;
  onGetAccredited: () => void;
}
export function DeveloperInfoPage({
  developerId,
  developerName,
  onClose,
  onGetAccredited
}: DeveloperInfoPageProps) {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // Map developer names to their logos
  const getDeveloperLogo = (name: string) => {
    const logoMap: Record<string, string> = {
      'Mountain View': 'https://cdn.magicpatterns.com/uploads/ht2zed5WJfpibcGTs2kKAi/Mountain-View-Logo-Vector.svg-.png',
      'Palm Hills': 'https://cdn.magicpatterns.com/uploads/e3xetC89TNSJtFzKEK9GJ9/OIP.McQBqob_yPFZovOPZDod3AHaHa.webp',
      'Hyde Park': 'https://cdn.magicpatterns.com/uploads/8vQhTfMrXW8bwweERT8mA7/OIP.xWHw7TazT7rFveGb0a9zNwHaHa.webp',
      'Emaar Misr': 'https://cdn.magicpatterns.com/uploads/wijYmcxqmndw1XGyexVnGN/Emaar-Misr-Logo.png',
      Sodic: 'https://cdn.magicpatterns.com/uploads/m7ECvP64WQu5Q5fDGkVyT2/OIP.heFoNUDluvlfTF84mNzC8AHaB6.webp',
      'Ora Developers': 'https://cdn.magicpatterns.com/uploads/qiVDQQJwbWPnXu1qEPHnnJ/1655298523997.jpg',
      'Tatweer Misr': 'https://cdn.magicpatterns.com/uploads/vFd4y3e6VTvKmbjouHn6Df/OIP.WU0po8LB04ePZzUToFmyKQHaD2.webp',
      Inertia: 'https://cdn.magicpatterns.com/uploads/gtoHa4YFoGm69rL7tSXhd6/OIP.8_yr1_3JwTWhYPh-6mszrAHaBG.webp'
    };
    return logoMap[name] || 'https://cdn.magicpatterns.com/uploads/ht2zed5WJfpibcGTs2kKAi/Mountain-View-Logo-Vector.svg-.png';
  };
  // Mock developer data
  const developer = {
    id: developerId,
    name: developerName,
    description: 'About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View About Mountain View',
    logo: getDeveloperLogo(developerName),
    projects: [{
      id: 1,
      image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=400&h=300&fit=crop'
    }, {
      id: 2,
      image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=400&h=300&fit=crop'
    }, {
      id: 3,
      image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=400&h=300&fit=crop'
    }, {
      id: 4,
      image: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=400&h=300&fit=crop'
    }, {
      id: 5,
      image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=400&h=300&fit=crop'
    }, {
      id: 6,
      image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=400&h=300&fit=crop'
    }]
  };
  return <div className="min-h-screen bg-neutral-bg pb-20 font-sans w-full" data-id="element-1457">
      <div className="w-full mx-auto bg-neutral-bg min-h-screen relative" data-id="element-1458">
        {/* Header */}
        <div className="bg-white px-4 py-4 safe-top flex items-center justify-between sticky top-0 z-10 shadow-sm" data-id="element-1459">
          <div className="w-10" data-id="element-1460"></div>
          <div className="flex-1" data-id="element-1461"></div>
          <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-neutral-bg rounded-full transition-colors" data-id="element-1462">
            <X className="w-6 h-6" data-id="element-1463" />
          </button>
        </div>

        <div className="px-4 pt-8 pb-4 space-y-6" data-id="element-1464">
          {/* Developer Logo and Info */}
          <div className="flex flex-col items-center text-center" data-id="element-1465">
            <div className="w-24 h-24 mb-4 flex items-center justify-center bg-white rounded-full p-3 shadow-sm" data-id="element-1466">
              <img src={developer.logo} alt={developer.name} className="w-full h-full object-contain" data-id="element-1467" />
            </div>

            <h1 className="text-2xl font-bold text-neutral-text mb-1 tracking-wide" data-id="element-1468">
              {developer.name.toUpperCase()}
            </h1>

            <button onClick={onGetAccredited} className="mt-4 bg-primary hover:bg-primary-dark text-white font-semibold px-8 py-3 rounded-full transition-colors" data-id="element-1469">
              Get Accredited
            </button>
          </div>

          {/* About Section */}
          <div className="bg-white rounded-xl p-4 shadow-sm" data-id="element-1470">
            <p className="text-sm text-gray-600 leading-relaxed" data-id="element-1471">
              {developer.description}
            </p>
          </div>

          {/* Projects Section */}
          <div data-id="element-1472">
            <h2 className="text-lg font-bold text-neutral-text mb-4" data-id="element-1473">
              Projects
            </h2>
            <div className="grid grid-cols-2 gap-3" data-id="element-1474">
              {developer.projects.map(project => <div key={project.id} className="bg-white rounded-xl overflow-hidden shadow-sm" data-id="element-1475">
                  <img src={project.image} alt={`Project ${project.id}`} className="w-full h-40 object-cover" data-id="element-1476" />
                </div>)}
            </div>
          </div>

          {/* Footer Message */}
          <div className="text-center py-6" data-id="element-1477">
            <p className="text-sm text-gray-600 mb-4" data-id="element-1478">
              Connect in order to contact {developer.name}
              <br data-id="element-1479" />
              Team Directly
            </p>
            <button onClick={onGetAccredited} className="bg-primary hover:bg-primary-dark text-white font-semibold px-8 py-3 rounded-full transition-colors" data-id="element-1480">
              Get Accredited
            </button>
          </div>
        </div>

        <BottomNav data-id="element-1481" />
      </div>
    </div>;
}